import React, { useEffect, useState } from 'react'

import {
    Button,
  } from "@material-tailwind/react";
import { getOneReportDetailsApi } from 'api/gestionStock';
import { updateRecouvrementDate } from 'api/recovry';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function EditeRecouvryNumberMontant({ selectedReportId, selectedRecovryInfo, selectedRecovryType, selectedRecovryIndex, selectedRecovryField }) {
    const [numberValue, setNumberValue] = useState("")
    const [montantValue, setMontantValue] = useState("")

    useEffect(() => {
        getInitialData();
    }, [selectedRecovryInfo]);

    const getInitialData = () => {
        try {
            if (selectedRecovryType === "Espece" || selectedRecovryType === "Virement") {
                setMontantValue(selectedRecovryInfo.montant ?? "")
                return
            }

            if (selectedRecovryType === "Cheque") {
                setNumberValue(selectedRecovryInfo.Ncheque ?? "")
            } else {
                setNumberValue(selectedRecovryInfo.NEffet ?? "")
            }
            setMontantValue(selectedRecovryInfo.Montant ?? "")
        }
        catch (err) {
            console.log(err)
        }
    }

    const handleEditeNumberMontant = async () => {
        try {
            const reportDetails = await getOneReportDetailsApi(selectedReportId);

            const key = selectedRecovryInfo.key ?? selectedRecovryIndex;

            if (selectedRecovryType === "Espece" || selectedRecovryType === "Virement") {
                reportDetails.Rapport.recouvrement[selectedRecovryType].montant = montantValue
            }
            else if (selectedRecovryType === "Cheque") {
                if (selectedRecovryField === "number") {
                    reportDetails.Rapport.recouvrement.Cheque.ChequeInfo[key].Ncheque = numberValue
                } else {
                    reportDetails.Rapport.recouvrement.Cheque.ChequeInfo[key].Montant = montantValue
                }
            }
            else {
                if (selectedRecovryField === "number") {
                    reportDetails.Rapport.recouvrement.Effet.EffetInfo[key].NEffet = numberValue
                } else {
                    reportDetails.Rapport.recouvrement.Effet.EffetInfo[key].Montant = montantValue
                }
            }

            withReactContent(Swal)
            .fire({
              icon: "warning",
              title: "Voulez-vous vraiment modifier ces valeurs ?",
              confirmButtonText: "Modifier",
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                await updateRecouvrementDate(selectedReportId, reportDetails.Rapport)
                Swal.fire("Modifiée", "", "success");
              }
            });
        }
        catch (err) {
            console.log(err)
        }
    }

  return (
    <div>
        <form style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', minWidth: '320px' }}>
                {selectedRecovryField === "number" ? (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label className="text-sm font-bold text-navy-700">
                            {selectedRecovryType === "Cheque" ? "N° Chèque" : "N° Effet"}
                        </label>
                        <input
                            type="text"
                            value={numberValue}
                            onChange={(e) => setNumberValue(e.target.value)}
                            style={{ border: '1px solid #ccc', padding: '8px', borderRadius: '4px' }}
                        />
                    </div>
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label className="text-sm font-bold text-navy-700">Montant</label>
                        <input
                            type="number"
                            value={montantValue}
                            onChange={(e) => setMontantValue(e.target.value)}
                            style={{ border: '1px solid #ccc', padding: '8px', borderRadius: '4px' }}
                        />
                    </div>
                )}
                <Button
                    variant="gradient"
                    color="#236571"
                    onClick={() => handleEditeNumberMontant()}
                    className="mr-1"
                >
                    <span>Modifier</span>
                </Button>
            </div>
        </form>
    </div>
  )
}

export default EditeRecouvryNumberMontant
